import { useMemo } from 'react';

import { arc } from 'd3-shape';

interface UseArcPathOptions {
  innerRadius: number;
  outerRadius: number;
  startAngle?: number;
  cornerRadius?: number;
}

const DEFAULT_START_ANGLE = 0;

const DEFAULT_CORNER_RADIUS = 0;

const useArcPath = ({
  innerRadius,
  outerRadius,
  startAngle = DEFAULT_START_ANGLE,
  cornerRadius = DEFAULT_CORNER_RADIUS,
}: UseArcPathOptions) =>
  useMemo(
    () =>
      arc<{ endAngle: number }>()
        .innerRadius(innerRadius)
        .outerRadius(outerRadius)
        .startAngle(startAngle)
        .cornerRadius(cornerRadius),
    [innerRadius, outerRadius, startAngle, cornerRadius]
  );

export { useArcPath };
